// src/utils.ts
function isString(input) {
  return typeof input === "string";
}
function isObject(input) {
  return typeof input === "object" && input?.constructor === Object;
}
function isArray(input) {
  return Array.isArray(input);
}
function Lowercase(str) {
  return str.toLowerCase();
}
function Uppercase(str) {
  return str.toUpperCase();
}
function Capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function Uncapitalize(str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

// src/parser/stringParser.ts
var CamelToDash = (str) => str.replace(/([A-Z])/g, (g) => "-" + g[0].toLowerCase());
var CamelToPascal = (str) => Capitalize(str);
var CamelToSnake = (str) => str.replace(/([A-Z])/g, (g) => "_" + g[0].toLowerCase());
var CamelToUpperDash = (str) => Uppercase(CamelToDash(str));
var CamelToUpperSnake = (str) => Uppercase(CamelToSnake(str));
var DashToCamel = (str) => str.replace(/(\-\w)/g, (g) => g[1].toUpperCase());
var DashToPascal = (str) => Capitalize(DashToCamel(str));
var DashToSnake = (str) => str.replace(/(\-)/g, "_");
var DashToUpperDash = (str) => Uppercase(str);
var DashToUpperSnake = (str) => Uppercase(DashToSnake(str));
var PascalToCamel = (str) => Uncapitalize(str);
var PascalToDash = (str) => CamelToDash(Uncapitalize(str));
var PascalToSnake = (str) => CamelToSnake(Uncapitalize(str));
var PascalToUpperDash = (str) => Uppercase(PascalToDash(str));
var PascalToUpperSnake = (str) => Uppercase(PascalToSnake(str));
var SnakeToCamel = (str) => str.replace(/(\_\w)/g, (g) => g[1].toUpperCase());
var SnakeToDash = (str) => str.replace(/(\_)/g, "-");
var SnakeToPascal = (str) => Capitalize(SnakeToCamel(str));
var SnakeToUpperDash = (str) => Uppercase(SnakeToDash(str));
var SnakeToUpperSnake = (str) => Uppercase(str);
var UpperDashToCamel = (str) => DashToCamel(Lowercase(str));
var UpperDashToDash = (str) => Lowercase(str);
var UpperDashToPascal = (str) => Capitalize(UpperDashToCamel(str));
var UpperDashToSnake = (str) => DashToSnake(UpperDashToDash(str));
var UpperDashToUpperSnake = (str) => Uppercase(UpperDashToSnake(str));
var UpperSnakeToCamel = (str) => SnakeToCamel(Lowercase(str));
var UpperSnakeToDash = (str) => str.replace(/(\_)/g, "-").toLowerCase();
var UpperSnakeToPascal = (str) => SnakeToPascal(Lowercase(str));
var UpperSnakeToSnake = (str) => Lowercase(str);
var UpperSnakeToUpperDash = (str) => Uppercase(UpperSnakeToDash(str));
function parse(input, type) {
  return {
    CamelToDash,
    CamelToPascal,
    CamelToSnake,
    CamelToUpperDash,
    CamelToUpperSnake,
    DashToCamel,
    DashToSnake,
    DashToPascal,
    DashToUpperSnake,
    DashToUpperDash,
    PascalToCamel,
    PascalToSnake,
    PascalToDash,
    PascalToUpperSnake,
    PascalToUpperDash,
    SnakeToCamel,
    SnakeToDash,
    SnakeToPascal,
    SnakeToUpperSnake,
    SnakeToUpperDash,
    UpperSnakeToCamel,
    UpperSnakeToSnake,
    UpperSnakeToDash,
    UpperSnakeToPascal,
    UpperSnakeToUpperDash,
    UpperDashToCamel,
    UpperDashToSnake,
    UpperDashToDash,
    UpperDashToPascal,
    UpperDashToUpperSnake
  }[type](input);
}

// src/parser/objectParser.ts
function objectParser(input, type) {
  const result = {};
  for (const property in input) {
    const parsedKey = parse(property, type);
    const value = input[property];
    if (isArray(value)) {
      result[parsedKey] = arrayParser(value, type);
    } else if (isObject(value)) {
      result[parsedKey] = objectParser(value, type);
    } else {
      result[parsedKey] = value;
    }
  }
  return result;
}

// src/parser/arrayParser.ts
function arrayParser(input, type) {
  return input.map((item) => {
    if (isArray(item))
      return arrayParser(item, type);
    if (isObject(item))
      return objectParser(item, type);
    return item;
  });
}

// src/parser/parser.ts
function converter(input, type) {
  let result;
  if (isString(input))
    result = parse(input, type);
  if (isArray(input))
    result = arrayParser(input, type);
  if (isObject(input))
    result = objectParser(input, type);
  return result;
}

// src/camelCase/camelCase.ts
function camelToDash(input) {
  return converter(input, "CamelToDash");
}
function camelToSnake(input) {
  return converter(input, "CamelToSnake");
}
function camelToPascal(input) {
  return converter(input, "CamelToPascal");
}
function camelToUpperSnake(input) {
  return converter(input, "CamelToUpperSnake");
}
function camelToUpperDash(input) {
  return converter(input, "CamelToUpperDash");
}

// src/dashCase/dashCase.ts
function dashToSnake(input) {
  return converter(input, "DashToSnake");
}
function dashToCamel(input) {
  return converter(input, "DashToCamel");
}
function dashToPascal(input) {
  return converter(input, "DashToPascal");
}
function dashToUpperSnake(input) {
  return converter(input, "DashToUpperSnake");
}
function dashToUpperDash(input) {
  return converter(input, "DashToUpperDash");
}

// src/pascalCase/pascalCase.ts
function pascalToCamel(input) {
  return converter(input, "PascalToCamel");
}
function pascalToSnake(input) {
  return converter(input, "PascalToSnake");
}
function pascalToDash(input) {
  return converter(input, "PascalToDash");
}
function pascalToUpperSnake(input) {
  return converter(input, "PascalToUpperSnake");
}
function pascalToUpperDash(input) {
  return converter(input, "PascalToUpperDash");
}

// src/snakeCase/snakeCase.ts
function snakeToCamel(input) {
  return converter(input, "SnakeToCamel");
}
function snakeToDash(input) {
  return converter(input, "SnakeToDash");
}
function snakeToPascal(input) {
  return converter(input, "SnakeToPascal");
}
function snakeToUpperSnake(input) {
  return converter(input, "SnakeToUpperSnake");
}
function snakeToUpperDash(input) {
  return converter(input, "SnakeToUpperDash");
}

// src/upperDashCase/upperDashCase.ts
function upperDashToCamel(input) {
  return converter(input, "UpperDashToCamel");
}
function upperDashToSnake(input) {
  return converter(input, "UpperDashToSnake");
}
function upperDashToDash(input) {
  return converter(input, "UpperDashToDash");
}
function upperDashToPascal(input) {
  return converter(input, "UpperDashToPascal");
}
function upperDashToUpperSnake(input) {
  return converter(input, "UpperDashToUpperSnake");
}

// src/upperSnakeCase/upperSnakeCase.ts
function upperSnakeToCamel(input) {
  return converter(input, "UpperSnakeToCamel");
}
function upperSnakeToSnake(input) {
  return converter(input, "UpperSnakeToSnake");
}
function upperSnakeToDash(input) {
  return converter(input, "UpperSnakeToDash");
}
function upperSnakeToPascal(input) {
  return converter(input, "UpperSnakeToPascal");
}
function upperSnakeToUpperDash(input) {
  return converter(input, "UpperSnakeToUpperDash");
}
export {
  camelToDash,
  camelToPascal,
  camelToSnake,
  camelToUpperDash,
  camelToUpperSnake,
  dashToCamel,
  dashToPascal,
  dashToSnake,
  dashToUpperDash,
  dashToUpperSnake,
  pascalToCamel,
  pascalToDash,
  pascalToSnake,
  pascalToUpperDash,
  pascalToUpperSnake,
  snakeToCamel,
  snakeToDash,
  snakeToPascal,
  snakeToUpperDash,
  snakeToUpperSnake,
  upperDashToCamel,
  upperDashToDash,
  upperDashToPascal,
  upperDashToSnake,
  upperDashToUpperSnake,
  upperSnakeToCamel,
  upperSnakeToDash,
  upperSnakeToPascal,
  upperSnakeToSnake,
  upperSnakeToUpperDash
};
